import { getterTypes, permissoes, routesNames, situacoes } from '@/core/constants'
import VigenciaFilter from '@/views/filters/vigencia-filter'
import AzEnum from '@azinformatica/loki/src/filters/az-enum'
import Situacoes from '@/core/constants/situacoes'
import infoCabecalho from '@/core/store/default/infoCabecalho'

const SEM_PROCESSO = 'Sem Processo'

const montaInformacoes = (info, state) => {
	const getTexto = (valor, fallback = SEM_PROCESSO) => valor || fallback

	const temProcessoSGPE = info.processo?.numeroSgpe

	const exibirPromotor = !!state.parametrosSistema?.isIntegracaoWeblicAtivo

	const isNumeroObrigatorio =
		!!state.parametrosSistema?.numeroDaAtaIsManual && info.situacao === Situacoes.ATA.EM_ELABORACAO.value

	return [
		new infoCabecalho(
			'Nº Edital',
			{ texto: temProcessoSGPE ? getTexto(info.processo.numero) : getTexto(info.numeroEdital, '---') },
			temProcessoSGPE ? 'processo' : 'numeroEdital',
		),
		new infoCabecalho(
			temProcessoSGPE ? 'Nº Processo SGPE' : 'Nº Processo',
			{ texto: temProcessoSGPE ? getTexto(info.processo.numeroSgpe) : getTexto(info.processo?.numero) },
			temProcessoSGPE ? 'processoSGPE' : 'processo',
		),
		new infoCabecalho('Nº Ata', { texto: getTexto(info.numero) }, 'numero', true, isNumeroObrigatorio),
		new infoCabecalho('Órgão Gerenciador', { texto: getTexto(info.unidadeOrganizacional?.sigla) }, 'orgao'),
		new infoCabecalho('Órgão Promotor', { texto: getTexto(info.processo?.unidadeOrganizacional?.sigla) }, 'promotor', false, false, exibirPromotor),
		new infoCabecalho('Descrição', { texto: getTexto(info.descricao, '') }, 'descricao'),
		new infoCabecalho('Vigência', { texto: VigenciaFilter(info.inicioValidade, info.fimValidade) }, 'vigencia'),
		new infoCabecalho('Situação', { texto: AzEnum(info.situacao, Situacoes.ATA).text }, 'situacao'),
	]
}

function montaAbas(informacoesAta) {
	let abas = {
		1: {
			titulo: 'Gestão da Ata',
			rota: { name: routesNames.ATA.ATA_ACESSAR_GESTAO_ATA_VIEW },
			permissao: null,
		},
		4: {
			titulo: 'Fiscais',
			rota: { name: routesNames.ATA.ATA_ACESSAR_FISCAIS_VIEW },
			permissao: permissoes.ataFiscaisListar,
		},
	}

	if (
		informacoesAta.situacao === situacoes.ATA.EFETIVADO.value ||
		informacoesAta.situacao === situacoes.ATA.CANCELADO.value
	) {
		abas[3] = {
			titulo: 'Infrações e Sanções',
			rota: { name: routesNames.ATA.ATA_ACESSAR_PENALIDADES_VIEW },
			permissao: permissoes.ataPenalidadesListar,
		}
	}

	if (
		informacoesAta.usuariosPodeCriarPedido ||
		informacoesAta.usuarioPodeVisualizarPedido ||
		informacoesAta.usuarioPermissaoAlterar ||
		informacoesAta.situacao === situacoes.ATA.HISTORICO_PRORROGACAO.value
	) {
		abas[2] = {
			titulo: 'Gestão do Pedido',
			rota: { name: routesNames.ATA.ATA_ACESSAR_GESTAO_PEDIDO_VIEW },
			permissao: permissoes.pedidoUtilizacaoVisualizar,
		}
	}

	return abas
}

export default {
	[getterTypes.ATA.GET_INFORMACOES_ATA]: (state) => state.informacoesAta,
	[getterTypes.ATA.GET_SITUACAO_DA_ATA]: (state) => state.informacoesAta.situacao,
	[getterTypes.ATA.GET_IS_ATA_ADESAO]: (state) => state.informacoesAta.isAdesao,
	[getterTypes.ATA.GET_ATA_PARA_CABECALHO]: (state, _, rootState) =>
		montaInformacoes(state.informacoesAta, rootState),
	[getterTypes.ATA.ABAS_INTERNAS_DA_ATA]: (state) => montaAbas(state.informacoesAta),
	[getterTypes.ATA.GET_TEM_PERMISSAO_EDICAO]: (state) => {
		return !!state.informacoesAta.usuarioPermissaoAlterar
	},
	[getterTypes.ATA.GET_USUARIO_PODE_VISUALIZAR_ACOMPANHAMENTO]: (state) => {
		return !!state.informacoesAta.usuarioPodeVisualizarAcompanhamento
	},
	[getterTypes.ATA.GET_PODE_VER_ADESOES_DO_ADERENTE]: (state) => {
		return !!state.informacoesAta.usuarioPodeVerAdesoesDoAderente
	},
	[getterTypes.ATA.GET_POSSUI_ADESOES_PARA_ANALISE_DO_GESTOR]: (state) => {
		return !!state.informacoesAta.possuiAdesoesParaAnaliseDoGestor
	},
	[getterTypes.ATA.GET_POSSUI_DOCUMENTO_TIPO_ATA_REGISTRO_PRECO]: (state) =>
		state.informacoesAta.possuiDocumentoTipoAtaRegistroPreco,
	[getterTypes.ATA.GET_POSSUI_DOCUMENTO_TIPO_ATA_REGISTRO_PRECO_SEM_CONCLUIR_EDICAO]: (state) =>
		state.informacoesAta.possuiDocumentoTipoAtaRegistroPrecoSemConcluirEdicao,
	[getterTypes.ATA.GET_POSSUI_DOCUMENTO_TIPO_ATA_REGISTRO_PRECO_NAO_ASSINADO]: (state) =>
		state.informacoesAta.possuiDocumentoTipoAtaRegistroPrecoNaoAssinado,
	[getterTypes.ATA.GET_IS_ENVIADA_PNCP]: (state) => state.informacoesAta.isEnviadaPncp,
	[getterTypes.ATA.GET_URL_PNCP]: (state) => state.informacoesAta.urlPncp,
	[getterTypes.ATA.GET_IS_MIGRACAO]: (state) => state.informacoesAta.isMigracao,
}
